import { NgModule } from '@angular/core';
import { BindHtmlCompileDirective } from './bind-html-compile.directive';

@NgModule({
    declarations: [BindHtmlCompileDirective],
    exports: [BindHtmlCompileDirective],
})
export class FiBindHtmlCompileModule {}
